import React, { useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import "./PPClasses.css";
import Header from "../../Header/Header";
import Tooltip from "react-bootstrap/Tooltip";
import { get } from "../../../app/shared/http";
import { OverlayTrigger } from "react-bootstrap";
import loadingIcon from "../../Spinner/loadingIcon.gif";
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../../app/util/HOC";
export function PPClassStudentsTopicScores() {
    const { isbn } = useParams();
    const history = useHistory();
    const location = useLocation();
    const classParams = location.state.ppClassInfo;
    const classStudParamas = location.state.ppStudentInfo;
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const ppProductId = localStorage.getItem('ppProductTagId');
    const { ppClassName, ppClassId, ppClassDescription } = classParams;
    const ppPageInfo = JSON.parse(localStorage.getItem('ppLandingInfo'));
    const ppIsbn = (isbn && isbn !== 'undefined') ? isbn : localStorage.getItem('bookIsbn');
    const [topicSearchTerm, setTopicSearchTerm] = useState('');
    const [classTopicScoresList, setClassTopicScoresList] = useState([]);
    const [isTopicScoresLoading, setIsTopicScoresLoading] = useState(false);
    useEffect(() => {
        getPPStudentTopicList();
    }, []);
    function getPPStudentTopicList() {
        const ppStdClassId = ppClassId;
        const ppStdSubjId = ppProductId;
        const ppStdProfId = userVO.userId;
        setIsTopicScoresLoading(true);
        get(`/PP/Professor/getClassPerformance?classId=${ppStdClassId}&professorId=${ppStdProfId}&subjectId=${ppStdSubjId}`, 'qpAPI')
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then(data => {
                setIsTopicScoresLoading(false);
                if (data && data.length > 0) {
                    setClassTopicScoresList(data);
                }
            }).catch(error => {
                setIsTopicScoresLoading(false);
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const handleTopicTabClick = (tabName) => {
        if (tabName === 'students') {
            history.push(`/pp-classes/${isbn}/pp-studentsdetails`, { ppClassInfo: classParams });
        } else if (tabName === 'topicScores') {
            history.push(`/pp-classes/${isbn}/pp-studentstopicscores`, { ppClassInfo: classParams, ppStudentInfo: classStudParamas });
        }
    }
    const handleSubTopicRomanConv = (num) => {
        var lookup = { m: 1000, cm: 900, d: 500, cd: 400, c: 100, xc: 90, l: 50, xl: 40, x: 10, ix: 9, v: 5, iv: 4, i: 1 }, roman = '', i;
        for (i in lookup) {
            while (num >= lookup[i]) {
                roman += i;
                num -= lookup[i];
            }
        }
        return roman;
    }
    const handlePPSubTopicPage = ({ ppSubTopicInfo }) => {
        history.push(`/pp-classes/${isbn}/pp-subtopicpage`, { ppClassInfo: classParams, ppStudentInfo: classStudParamas, ppSubTopicInfo });
    }
    const handleTopicSearch = (e) => {
        const topicSearrVal = document.getElementById("searchTopicId").value;
        if ((e.key === 'Backspace' || e.key === 'Delete') && topicSearrVal.length === 1) {
            getPPStudentTopicList();
        }
    }
    let topicListData = [...classTopicScoresList] || [];
    let topicListFilteredData = topicListData && topicListData.filter((ppClassTopic) => {
        const topicData = ppClassTopic.topicName.toLowerCase().includes(topicSearchTerm.toLowerCase());
        if (topicData) {
            return topicData;
        } else {
            if (ppClassTopic.ppSubTopicList && !ppClassTopic.ppSubTopicList.length) {
                return topicData;
            } else {
                const subTopicList = ppClassTopic.ppSubTopicList && ppClassTopic.ppSubTopicList.filter((topicSubData) => {
                    return topicSubData.subTopicName.toLowerCase().includes(topicSearchTerm.toLowerCase());
                });
                if (subTopicList && subTopicList.length) {
                    ppClassTopic['ppSubTopicList'] = subTopicList;
                    return true;
                } else {
                    return false;
                }
            }
        }
    });
    const topicListFiltered = (topicListFilteredData.length && topicSearchTerm === '') ? topicListFilteredData : null;
    const topicListFilterData = (topicListFilteredData.length && topicSearchTerm !== '') ? topicListFilteredData : null;
    const topicListSearch = topicListFiltered ? topicListFiltered : topicListFilterData;
    const topicInfoToolTip = {
        quizAttemptStud: <Tooltip id="tooltip" className="ppClassDropTooltip"> The progress bar below only reflects one attempt per student and does not take into account any additional attempts made by the same student.</Tooltip>,
        quizAvgScorStud: <Tooltip id="tooltip" className="ppClassDropTooltip"> The average score is calculated based on the most recent scores of each student.</Tooltip>
    }
    return (
        <>
            <Header userVO={userVO} pageName="PPClassStudentsTopicScores" isbn={ppIsbn}></Header>
            <div className='container'>
                <div className="card ppClassContainerSection">
                    <div className="card-body ppvContainerCard">
                        <div className="row">
                            <div className="col-12 p-0">
                                {
                                    ppPageInfo &&
                                    <div className="ppvLogoContainer pt-4">
                                        <p>
                                            <span className='ppvCommonStyle ppvLogoBoldText'>PracticePerfect</span>
                                            <span className='ppvCommonStyle ppvLogoText'>{ppPageInfo.ProductName}</span>
                                        </p>
                                    </div>
                                }
                                <div className="sticky-top TS-TabFirstSticky">
                                    <div className="titleDesp-heights pt-2">
                                        <h4 className={ppClassName.length > 84 ? "ppClassesTitle ppClassesTitleGT mb-1" : "ppClassesTitle ppClassesTitleLT mb-1"}>{ppClassName}</h4>
                                        {
                                            ppClassDescription !== "" ?
                                                <p className={ppClassDescription.length > 168 ? "ppClassesDescp h6 pt-xl-3 pt-lg-3 pt-md-3 ppClassesDescpGT" : "ppClassesDescp h6 pt-xl-3 pt-lg-3 pt-md-3 ppClassesDescpLT"}>{ppClassDescription}</p> : null
                                        }
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding mt-4 ">
                                        <ul className="nav nav-tabs navtab-color">
                                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 no-padding">
                                                <li>
                                                    <a className="nav-link cqStdDetailsTiltleTab" onClick={() => handleTopicTabClick('students')}>
                                                        Students
                                                    </a>
                                                </li>
                                            </div>
                                            <div className="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 no-padding">
                                                <li>
                                                    <a className="nav-link cqStdDetailsTiltleTab active" onClick={() => handleTopicTabClick('topicScores')}>
                                                        Topic Scores
                                                    </a>
                                                </li>
                                            </div>
                                        </ul>
                                        <div className="dashBoardSearchIconDivs mt-4">
                                            <input data-testid="search_input" title="Search inside your books for topics, cases, or keywords" id="searchTopicId" className="classStdSearchInput" type="text" placeholder="Search Topic"
                                                value={topicSearchTerm} onChange={(e) => setTopicSearchTerm(e.target.value)} onKeyDown={(e) => handleTopicSearch(e)} />
                                            <i data-testid="search" className='fa fa-search classStdSearchIcon text-dark' title='Search inside your books for topics, cases, or keywords'></i>
                                        </div>
                                        <div className="row pt-4 ">
                                            <div className="col-xl-6 col-lg-6 col-md-5 col-sm-4 col-4">
                                                <p className="StdDetailTableTitle ml-4 mt-4 mb-1">Topic</p>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-5 px-xl-3 px-lg-3 px-md-3 px-0">
                                                <div className="StdDetailTableTitle px-xl-4 px-lg-4 px-md-2 px-3 d-flex text-xl-center text-lg-left">
                                                    <div>
                                                        <OverlayTrigger placement="top" overlay={topicInfoToolTip.quizAttemptStud}>
                                                            <i className='fa fa-info-circle text-primary ml-xl-3 ml-lg-2 ml-md-4 ml-3 mr-1 classTabIconsColor'></i>
                                                        </OverlayTrigger>
                                                    </div>
                                                    <div>
                                                        No. of students attempted (Out of {classStudParamas.total_no_of_students_enrolled})
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" col-xl-2 col-lg-2 col-md-2 col-sm-2 col-3 pl-0 pl-xl-2 pl-lg-2 pl-md-2 pr-0">
                                                <div className="StdDetailTableTitle text-center d-flex">
                                                    <div>
                                                        <OverlayTrigger placement="top" overlay={topicInfoToolTip.quizAvgScorStud}>
                                                            <i className='fa fa-info-circle text-primary ml-xl-3 ml-lg-5 ml-3 mr-1 classTabIconsColor'></i>
                                                        </OverlayTrigger>
                                                    </div>
                                                    <div>Average Scores (%)</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {
                                        (topicListSearch && topicListSearch.length > 0) ?
                                            topicListSearch.map((ppClassTopic, index) => {
                                                const { topicName } = ppClassTopic;
                                                return (
                                                    <>
                                                        <div className="ppClassStdTopic p-2 ppTopicFont-size pl-4">{(index + 1) + ". " + topicName}</div>
                                                        {
                                                            ppClassTopic.ppSubTopicList && ppClassTopic.ppSubTopicList.map((ppSubTopic, index) => {
                                                                const { subTopictagId, subTopicName } = ppSubTopic;
                                                                return (
                                                                    <>
                                                                        <div className="row border mx-0">
                                                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-4 col-5 pr-xl-4 pr-lg-4 pr-md-4 pr-0">
                                                                                <div data-testid="sub_topic" className="ppClassStdSub-Topic ppTopicFont-size my-2 pl-xl-4 pl-lg-4 pl-md-4 pl-2 d-flex" onClick={() => handlePPSubTopicPage({ ppSubTopicInfo: { topicName, subTopictagId, subTopicName } })}>
                                                                                    <div>{handleSubTopicRomanConv(index + 1) + "."} </div><div>&nbsp;</div><div>{subTopicName}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-4 pr-xl-5 pr-lg-5 pr-md-4 pr-0 pl-xl-5 pl-lg-5 pl-md-2 pl-0">
                                                                                <div className="progress ppClassTopicProgress my-2">
                                                                                    {
                                                                                        ppSubTopic.attemptedCount !== undefined && ppSubTopic.totalStudentCount !== undefined ?
                                                                                            <div className="progress-bar ppClassTopicProgress-bar" style={{ width: ppSubTopic.attemptedCount ? ((ppSubTopic.attemptedCount * 100) / ppSubTopic.totalStudentCount) + "%" : 0 + "%" }}> <span className={ppSubTopic.attemptedCount === 0 ? "topicScoreProgressBarLessThan10" : (((ppSubTopic.attemptedCount * 100) / ppSubTopic.totalStudentCount) < 10 ? "topicScoreProgressBarLessThan10" : "text-light")} >{ppSubTopic.attemptedCount}</span></div>
                                                                                            : null
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-3">
                                                                                <p className="ppTopicFont-size text-center my-2 pr-0 pl-xl-3 pl-lg-5 pl-3">{(ppSubTopic.score ? ppSubTopic.score : "0")}</p>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                )
                                            })
                                            :
                                            (
                                                isTopicScoresLoading ?
                                                    <div className="text-center">
                                                        <img src={loadingIcon} width="20px" height="21px" alt=""></img>
                                                    </div>
                                                    :
                                                    <div className="text-center" style={{ fontFamily: 'Fira Sans' }}>No topic or subtopic found</div>
                                            )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withAuth(PPClassStudentsTopicScores);